import { render, staticRenderFns } from "./PLC.vue?vue&type=template&id=4669f514&"
import script from "./PLC.vue?vue&type=script&lang=js&"
export * from "./PLC.vue?vue&type=script&lang=js&"
import style0 from "./PLC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports